import { FC } from 'react';
import { Box, Dialog, useTheme } from '@mui/material';

import { CloseCheckImageIcon } from '@icons/CloseCheckImageIcon';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	imageResourcesPath: string;
}

export const FullScreenDialog: FC<Props> = ({ isOpen, onClose, imageResourcesPath }) => {
	const theme: any = useTheme();
	const { trackRefineEvent } = useAnalytics();

	const orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
	if (orientation === 'landscape') {
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.OUCF_CUSTOMER_ROTATES_SCREEN);
	}

	const handleClose = (e: any, r: any) => {
		onClose();
	};
	return (
		<Dialog open={isOpen} onClose={handleClose}>
			<Box
				sx={{
					height: 'auto',
					backgroundColor: theme.palette.appBackground,
				}}>
				<Box
					id={'closeCheck'}
					onClick={onClose}
					sx={{
						backgroundColor: 'transparent',
						position: 'absolute',
						zIndex: 1000,
						border: 'none',
						right: '0',
						outline: 'none',
						cursor: 'pointer',
						transition: 'transform 0.3s ease-in-out',
						'&:hover': {
							transform: 'scale(1.2)',
							outline: 'none',
							border: 'none',
						},
					}}>
					<CloseCheckImageIcon />
				</Box>
				<img
					src={imageResourcesPath}
					alt="Full screen"
					style={{
						width: '100%',
						height: orientation === 'portrait' ? 'auto' : '100%',
						borderRadius: '10px',
						border: '1px solid #B2C5FF',
						boxShadow: '0px 0px 6px 0px rgba(15, 21, 47, 0.05), 0px 3px 6px 0px rgba(15, 21, 47, 0.05)',
					}}
				/>
			</Box>
		</Dialog>
	);
};
